import React, { FC } from 'react';
import * as StyledStyleguide from './styleguide.styles';
import { Container, Columns, Column } from '../../components/base/grid';
import { H1, H2, H3, H4, H5, H6, P, Ul, Li, A } from '../../components/base/typography';
import { ReactComponent as IconCar } from '../../icons/car.svg';
import { ReactComponent as IconEmojiWink } from '../../icons/emoji-wink.svg';
import { ReactComponent as IconHouse } from '../../icons/house.svg';
import { ReactComponent as IconLocation } from '../../icons/location.svg';
import { ReactComponent as IconLogo } from '../../icons/logo.svg';
import { ReactComponent as IconMailOpen } from '../../icons/mail-open.svg';
import { ReactComponent as IconSearch } from '../../icons/search.svg';
import { ReactComponent as IconShipment } from '../../icons/shipment.svg';
import { ReactComponent as IconTags } from '../../icons/tags.svg';
import { ReactComponent as IconUserChat } from '../../icons/user-chat.svg';
import { ReactComponent as IconUser } from '../../icons/user.svg';
import theme from '../../constants/theme';
import FormikTest from '../../components/formikTest';

interface Props {}

const Styleguide: FC<Props> = () => {
	return (
		<StyledStyleguide.Wrapper>
			<Container>
				<div>
					<H1 marginBottom="3rem" marginTop="8rem">
						Icons
					</H1>
					<IconCar />
					<IconEmojiWink />
					<IconHouse />
					<IconLocation />
					<IconLogo />
					<IconMailOpen />
					<IconSearch />
					<IconShipment />
					<IconTags />
					<IconUserChat />
					<IconUser />
				</div>
				<section style={{ padding: '30px 0' }}>
					<H1 marginBottom="3rem" marginTop="3rem">
						Hlekkir
					</H1>
					<div>
						<A>Ég er að fá sendingu frá útlöndum, hvernig sendi ég ykkur reikninginn?</A>
					</div>
					<div>
						<A>Hvað þarf að hafa í huga þegar ég versla á netinu?</A>
					</div>
					<div>
						<A>Sjá nánar</A>
					</div>
					<div>
						<A>The quick brown fox jumps over the lazy dog</A>
					</div>
				</section>
				<section style={{ padding: '30px 0' }}>
					<H1 marginBottom="3rem" marginTop="3rem">
						Listar
					</H1>
					<Ul>
						<Li>Umboð til tollskýrslugerðar</Li>
						<Li>Vörureikning</Li>
						<Li>Tilkynningu um tollsendingu</Li>
						<Li>Önnur fylgiskjöl</Li>
						<Li>Valkvætt: Umboð til tollskýrslugerðar EPG sendingar</Li>
					</Ul>
				</section>
				<section style={{ padding: '30px 0' }}>
					<H1 marginBottom="3rem" marginTop="3rem">
						Typography
					</H1>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 100 }}>Font weight 100</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 200 }}>Font weight 200</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 300 }}>Font weight 300</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 400 }}>Font weight 400</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 500 }}>Font weight 500</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 600 }}>Font weight 600</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 700 }}>Font weight 700</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: 800 }}>Font weight 800</div>
					<div
						style={{
							fontSize: '6rem',
							lineHeight: '6rem',
							fontWeight: 900,
							marginBottom: '3rem',
						}}>
						Font weight 900
					</div>
					<P>
						{`
								Lorem ipsum dolor sit amet, consectetur adipiscing elit,
								sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
								Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
								Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
							`}
					</P>
					<H1 marginBottom="3rem" marginTop="3rem">
						Headings
					</H1>
					<H1 marginBottom="2rem" style={{ maxWidth: '44.3rem' }}>
						Nú getur þú greitt á netinu
					</H1>
					<H2 marginBottom="2rem">Pósthús eða póstbox</H2>
					<H3 marginBottom="2rem">Minn Póstur</H3>
					<H4 marginBottom="2rem">
						Mikilvægt er að merkja bréf til útlanda með A eða B miða á greinilegum stað utanáskriftar megin
						til að tryggja að bréfin fái rétta meðhöndlun.
					</H4>
					<H5 marginBottom="2rem" style={{ maxWidth: '36.1rem' }}>
						Sæktu pakkann þegar þér hentar, það kostar ekkert aukalega
					</H5>
					<H6 marginBottom="2rem">Verðskrá</H6>
				</section>
				<section style={{ padding: '30px 0' }}>
					<H1 marginBottom="3rem" marginTop="3rem">
						Colors
					</H1>
					<div>
						<span>Generator available at </span>
						<a href="https://palx.jxnblk.com/" target="_blank" rel="noopener noreferrer">
							Palx
						</a>
					</div>
					<Columns>
						{Object.keys(theme.colors).map((key, index) => {
							return (
								<Column key={index} tablet={1 / 9}>
									<StyledStyleguide.Cube background={theme.colors[key]}>{key}</StyledStyleguide.Cube>
								</Column>
							);
						})}
					</Columns>
				</section>
				<FormikTest />
			</Container>
		</StyledStyleguide.Wrapper>
	);
};

export default Styleguide;
